import { ReactComponent as EmailSVG } from "./email-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconEmail(props) {
  return <SvgIcon {...props} component={EmailSVG} viewBox="0 0 16 11" />;
}